export const NewHardcodedPageComponent = (props: {
  props: NewHardcodedPageComponentProps;
}) => {
  return <>{props.props.page}</>;
};

export type NewHardcodedPageComponentProps = {
  type: "hardcoded_page";
  page: JSX.Element;
};
